<template>
  <div class="detail-main">
    <div class="content">
      <div>
        为保障APP相关功能的实现与应用的安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们对接入的相关第三方SDK在目录中列明：
      </div>
      <!-- android -->
      <h2>Android</h2>
      <div>
        <strong class="sub-title">神策SDK</strong>
        <p class="left-line">
          收集的数据：设备属性信息（Andriod
          ID/OAID/IDFA/IDFV/UUID）、位置信息、网络信息、设备硬件信息、操作系统信息、应用信息、手机加速度传感器用来获取手机屏幕方向数据
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：数据统计与分析</p>
        <p class="left-line">
          官网链接：
          <a href="https://www.sensorsdata.cn" class="link">https://www.sensorsdata.cn/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">QQ</strong>
        <p class="left-line">
          收集的数据：操作系统信息、设备型号信息、剪切板、相册、内存卡权限、应用列表信息
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：帮助用户分享至第三方应用、第三方支付</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.tencent.com/" class="link">https://open.tencent.com/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">微信/腾讯开放平台</strong>
        <p class="left-line">收集的数据：图片或内容、微信头像、昵称信息、支付信息</p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：帮助用户分享至第三方应用、第三方支付</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.weixin.qq.com/" class="link">https://open.weixin.qq.com/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">微博/新浪</strong>
        <p class="left-line">
          收集的数据：设备型号、设备标识符（如IMEI/ AndroidID/ IDFA/ OPENUDID/ GUID/
          OAID）、设备MAC地址、电信运营商等软硬件特征信息
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：帮助用户分享至新浪微博应用</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.weibo.com/" class="link">https://open.weibo.com/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">Alipay（支付宝）</strong>
        <p class="left-line">
          收集的数据：Android
          ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP
          地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：帮助用户在应用内使用支付宝</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.alipay.com/" class="link">https://open.alipay.com/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">华为push</strong>
        <p class="left-line">
          收集的数据：应用信息、设备信息（AAID、设备标识符、设备硬件信息、系统基本信息、系统设置）
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：推送消息</p>
        <p class="left-line">
          官网链接：
          <a href="https://developer.huawei.com/" class="link">https://developer.huawei.com/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">小米 push/小米推送</strong>
        <p class="left-line">
          收集的数据：设备标识符（如Android ID、OAID）、应用信息、设备信息、网络信息（本地处理）
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：推送消息</p>
        <p class="left-line">
          官网链接：
          <a href="https://dev.mi.com/" class="link">https://dev.mi.com/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">Vivo push</strong>
        <p class="left-line">
          收集的数据：设备标识信息、应用软件信息、设备制造商、网络相关信息、设备类型
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：推送消息</p>
        <p class="left-line">
          官网链接：
          <a href="https://dev.vivo.com.cn/" class="link">https://dev.vivo.com.cn/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">oppo push/oppo 推送</strong>
        <p class="left-line">
          收集的数据：设备相关信息、应用信息、消息发送结果、通知栏状态、锁屏状态
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：推送消息</p>
        <p class="left-line">
          官网链接：
          <a href="https://push.oppo.com/" class="link">https://push.oppo.com/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">中国移动 一键登录</strong>
        <p class="left-line">
          收集的数据：网络类型、网络地址（ip地址）、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商
        </p>
        <p class="left-line">使用目的：帮助用户一键登录APP</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.home.10086.cn/" class="link">https://open.home.10086.cn/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">阿里云文件上传服务(oss)</strong>
        <p class="left-line">
          收集的数据：系统版本、mac地址、IP、MAC、App版本信息、设备型号、ip地址、网络信息、网络连接
        </p>
        <p class="left-line">使用目的：上传用户文件(头像、录音、日志等)</p>
        <p class="left-line">
          官网链接：
          <a href="https://cn.aliyun.com/product/oss" class="link"
            >https://cn.aliyun.com/product/oss</a
          >
        </p>
      </div>
      <div>
        <strong class="sub-title">Sentry</strong>
        <p class="left-line">
          收集的数据：系统版本,mac地址,App版本信息,设备型号,ip地址,网络信息,Android_ID,传感器信息。
        </p>
        <p class="left-line">使用目的：帮助用户查询操作问题，不向第三方传输数据。</p>
        <p class="left-line">
          官网链接：
          <a href="https://sentry.io/" class="link">https://sentry.io/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">华为分析SDK（Android版）</strong>
        <p class="left-line">第三方名称：华为软件技术有限公司</p>
        <p class="left-line">
          收集个人信息类型：应用信息、设备信息、位置信息、网络信息、设备信息（OAID）、应用设置信息
        </p>
        <p class="left-line">使用目的：为开发者应用提供数据采集、分析服务</p>
        <p class="left-line">
          官网链接：
          <a
            href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/android-sdk-data-security-0000001050745153"
            class="link"
            >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/android-sdk-data-security-0000001050745153</a
          >
        </p>
      </div>
      <div>
        <strong class="sub-title">移动安全联盟 OAID SDK</strong>
        <p class="left-line">
          收集的数据：收集的数据：设备制造商、设备型号、设备品牌、网络运营商名称
        </p>
        <p class="left-line">
          使用目的：获取
          oaid（设备制造商、设备型号、设备品牌，用于判断终端调用接口；设备网络运营商名称，用于判断虚拟机环境；APP
          包名，用于校验签名）
        </p>
        <p class="left-line">
          官网链接：
          <a href="http://www.msa-alliance.cn/col.jsp?id=122" class="link"
            >http://www.msa-alliance.cn/col.jsp?id=122</a
          >
        </p>
      </div>
      <div>
        <strong class="sub-title">钉钉分享</strong>
        <p class="left-line">收集的数据：分享的图片或内容</p>
        <p class="left-line">使用目的：帮助用户分享至第三方应用</p>
        <p class="left-line">
          官网链接：
          <a
            href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html"
            class="link"
            >https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html</a
          >
        </p>
      </div>
      <div>
        <strong class="sub-title">腾讯 X5 浏览器</strong>
        <p class="left-line">
          收集的数据：设备信息、Wi-Fi状态和参数、位置信息、附近Wi-Fi、CellID、设备信息、标识符（OAID等）、应用信息、广告数据
        </p>
        <p class="left-line">使用目的：用于应用内识别扫描的二维码、方便用户快速找到目标项目</p>
        <p class="left-line">
          官网链接：
          <a href="https://x5.tencent.com/tbs/index.html" class="link"
            >https://x5.tencent.com/tbs/index.html</a
          >
        </p>
      </div>
      <div>
        <strong class="sub-title">极光推送（com.aurora，com.engagelab）</strong>
        <p class="left-line">
          收集的数据：设备标识符、设备硬件信息、操作系统信息、网络信息、推送信息日志
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：为 APP 用户提供信息推送服务</p>
        <p class="left-line">
          官网链接：
          <a href="https://www.jiguang.cn/push" class="link">https://www.jiguang.cn/push</a>
        </p>
        <p class="left-line">
          隐私政策链接：
          <a href="https://www.jiguang.cn/license/privacy" class="link"
            >https://www.jiguang.cn/license/privacy</a
          >
        </p>
      </div>
      <!-- iOS -->
      <h2>iOS</h2>
      <div>
        <strong class="sub-title">Alipay（支付宝）</strong>
        <p class="left-line">
          收集的数据：Android
          ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP
          地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：帮助用户在应用内使用支付宝</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.alipay.com/" class="link">https://open.alipay.com/</a>
        </p>
      </div>

      <div>
        <strong class="sub-title">神策SDK</strong>
        <p class="left-line">
          收集的数据：设备属性信息（OAID/IDFA/IDFV/UUID）、位置信息、网络信息、设备硬件信息、操作系统信息、应用信息、手机加速度传感器用来获取手机屏幕方向数据
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">使用目的：数据统计与分析</p>
        <p class="left-line">
          官网链接：
          <a href="https://www.sensorsdata.cn" class="link">https://www.sensorsdata.cn/</a>
        </p>
      </div>
      <div>
        <strong class="sub-title">QQ分享</strong>
        <p class="left-line">
          收集的数据：操作系统信息、设备型号信息、剪切板、相册、内存卡权限、应用列表信息
        </p>
        <p class="left-line">使用目的：帮助用户分享至第三方应用</p>
        <p class="left-line">
          官网链接：
          <a href="https://connect.qq.com/index.html" class="link"
            >https://connect.qq.com/index.html</a
          >
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
      </div>

      <div>
        <strong class="sub-title">微信分享/腾讯开放平台</strong>
        <p class="left-line">收集的数据：图片或内容、微信头像、昵称信息、支付信息</p>
        <p class="left-line">使用目的：帮助用户分享至第三方应用</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.weixin.qq.com/" class="link">https://open.weixin.qq.com/</a>
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
      </div>

      <div>
        <strong class="sub-title">微博分享</strong>
        <p class="left-line">
          收集的数据：设备型号、设备标识符（如IMEI/ AndroidID/ IDFA/ OPENUDID/ GUID/
          OAID）、设备MAC地址、电信运营商等软硬件特征信息
        </p>
        <p class="left-line">使用目的：帮助用户分享至新浪微博</p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.weibo.com/" class="link">https://open.weibo.com/</a>
        </p>
      </div>

      <div>
        <strong class="sub-title">中国移动 一键登录</strong>
        <p class="left-line">
          收集的数据：网络类型、网络地址（ip地址）、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商
        </p>
        <p class="left-line">使用目的：帮助用户一键登录APP</p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">
          官网链接：
          <a href="https://open.home.10086.cn/" class="link">https://open.home.10086.cn/</a>
        </p>
      </div>

      <div>
        <strong class="sub-title">钉钉分享</strong>
        <p class="left-line">收集的数据：分享的图片或内容</p>
        <p class="left-line">使用目的：帮助用户分享至第三方应用</p>
        <p class="left-line">
          官网链接：
          <a
            href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html"
            class="link"
            >https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html</a
          >
        </p>
      </div>

      <div>
        <strong class="sub-title">阿里云文件上传服务(oss)</strong>
        <p class="left-line">
          收集的数据：系统版本、mac地址、IP、MAC、App版本信息、设备型号、ip地址、网络信息、网络连接
        </p>
        <p class="left-line">个人信息类型：个人常用设备信息</p>
        <p class="left-line">
          官网链接：
          <a
            href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html"
            class="link"
            >https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html</a
          >
        </p>
      </div>
    </div>
    <safe-area-bottom />
  </div>
</template>

<script>
import SafeAreaBottom from "@/components/safe-area/safe-area-bottom.vue"
export default {
  components: {
    SafeAreaBottom
  }
}
</script>

<style>
.detail-main {
  font-size: 20px;
  padding: 0 10px !important;
}

.content {
  padding-top: 0 !important;
}

a {
  -webkit-touch-callout: none;
  text-decoration: none;
  pointer-events: none;
}

h2 {
  margin-top: 16px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

p,
div {
  font-size: 14px;
  color: #272727;
  line-height: 20px;
  text-align: justify;
}

div {
  padding: 10px 0 !important;
}

.left-line {
  text-align: left;
  word-break: break-all;
}

.right-line {
  text-align: right;
}

.have-items {
  padding-left: 2px;
}
</style>
